import React from 'react';
import Dialog, { IDialogProps } from '@/ui/dialog';
import { Share } from '@/ui/svg';
import { Button } from '@/ui/buttons';
import clsx from 'clsx';
import { useUtils } from '@bitbot/shared/bridge';

export default function ReadyToClaimDialog(props: IDialogProps) {
  const utils = useUtils();
  return (
    <Dialog {...props}>
      <div className="flex flex-col justify-between flex-grow font-nunito_sans px-6">
        <div className="text-[20px] font-bold tracking-[-0.48px]">
          Ready to claim?
        </div>
        <div className=" text-secondary leading-[1.5] mt-6 tracking-thin">
          If you participated in the presale, you can now claim your
          purchased $BITBOT tokens from the official website. Would you
          like to be redirected to the website?
        </div>
        <div className="flex justify-center">
          <Button
            size="sm"
            className={clsx('mt-4 bg-white !text-black flex gap-[10px] ')}
            onClick={async () => {
              utils?.openLink('https://bitbot.tg/');
              setTimeout(() => {
                props.toggle(false);
              }, 500);
            }}
          >
            <Share /> Open website
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
